import { render, staticRenderFns } from "./province.vue?vue&type=template&id=475e7362&"
import script from "./province.vue?vue&type=script&lang=ts&"
export * from "./province.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports